const ACCENT = '#873be8'; //цвет акцента #873be8 #009BFF
const TITLE = 'ZenWare'; //название
const SCHEME = 'dark' //dark-light тема по умолчанию;
const ReCaptchaKey = '6Lf7yrgaAAAAAE7Tub5J5M8jA12SSXh553oJK1-9' //ключ сайта от капчи 6LepNtkZAAAAAHkOAoE8AmiJYG3G_flmvBNEV-Pe
const NAV_BUTTONS = [{title: 'HWID', link: 'https://zware.space/HWID.jar'},{title: 'Download', link: 'https://zware.space/download.php'}];

export {ACCENT, SCHEME, TITLE,NAV_BUTTONS, ReCaptchaKey};
